module.exports = __webpack_public_path__ + "media/images/rides/driver1-75b2b1a3a6e17597e7a76bfe4f9186b0.png";